import { configureStore } from "@reduxjs/toolkit";
import storeReducer from "@/features/business/api/Slice";
import authReducer from "@/features/auth/api/slice";
import { redirect } from "@tanstack/react-router";
import { baseSplitApi } from "@/services";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    // user: userReducer,
    store: storeReducer,
    [baseSplitApi.reducerPath]: baseSplitApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseSplitApi.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;


export async function requireAuth(location: { href: string }) {
  const state = store.getState() as RootState;
  if (!state.auth.currentUser) {
    throw redirect({
      to: '/login',
      search: {
        redirect: location.href,
      },
    });
  }
}
export function redirectIfAuth() {
  const state = store.getState() as RootState;
  const isLoggedIn = !!state.auth.user;

  if (isLoggedIn) {
    throw redirect({ to: '/dashboard' });
  }
}